import React from 'react';
import { CardTitle, Link, Typography } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import PropTypes from 'prop-types';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import { triggerAnalyticsCustomEvent } from '../../utils/analyticsEvents';

const QuotesHeader = ({ hideActionLink = false }) => {
  const {
    loading,
    error,
    hasQuotes,
    isMobile,
    hideViewAllSuffix
  } = useQuoteContext();

  // Matches QuotesContent: a background refresh of cached quotes keeps the header.
  if ((loading && !hasQuotes) || error) return null;

  const viewAllQuotesClick = () => {
    triggerAnalyticsCustomEvent('quotes.stash-click', {
      component: 'view all'
    });
  };

  return (
    <div
      className="sui-pt-1"
    >
      <CardTitle
        header={(
          <div className="sui-flex sui-gap-3 sui-items-center">
            <Orders />
            <div className="sui-flex sui-gap-2 sui-items-center">
              <Typography variant="h4" weight="display">
                Quotes
              </Typography>
            </div>
          </div>
        )}
        data-test-id="quotes-header"
        actionPosition="end"
        action={(!isMobile && !hideActionLink) && (
          <Link onClick={viewAllQuotesClick} href="/quote/list">
            {hideViewAllSuffix ? 'View All' : 'View All Quotes'}
          </Link>
        )}
      />
    </div>
  );
};

QuotesHeader.propTypes = {
  hideActionLink: PropTypes.bool
};

export default QuotesHeader;
